export default {
  created() {
    let merchantId = this.$store.getters.userInfo.merchantId
    let platformId = this.getPlatformConfig().platformId
    this.queryParams = { platformId, merchantId }
  },
  data() {
    return {
      queryParams: {}
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'GuWeiInvitationRecord', title: '好友邀请记录' },
      { name: 'GuWeiPolicy', title: '防疫政策' },
      { name: 'GuWeiAccount', title: '关联账号' },
      { name: 'GuWeiSetting', title: '设置' }
    ])
  },
  methods: {}
}